import { Injectable } from '@angular/core';
import { APIHttpService } from './api-http.service';
import { Observable, of } from 'rxjs';
import { ICtrlResponse } from '../interfaces/api.interface';
import { IBroker, IBrokerage } from '@takectrl-multiapp/svcs-share-config';
import { ApiCacheService } from './api-cache.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class APIBrokerService {
  private readonly CACHE_KEYS = {
    BROKERS: (searchTerm: string) => `brokers_search_${searchTerm}`,
    BROKERAGE: 'brokerage',
    AllBROKERS: 'all_brokers'
  };

  constructor(private readonly ctrlApiHttpService: APIHttpService, private readonly cacheService: ApiCacheService) {}

  getBrokers(brokerName: string): Observable<ICtrlResponse<IBroker[]>> {
    const cached = this.cacheService.get(this.CACHE_KEYS.BROKERS(brokerName));
    if (cached) {
      return of(cached);
    }

    return this.ctrlApiHttpService
      .get(`/brokers/search/?searchTerm=${brokerName}&cutoff=50`, {})
      .pipe(tap((response) => this.cacheService.set(this.CACHE_KEYS.BROKERS(brokerName), response)));
  }

  getBrokerage(): Observable<ICtrlResponse<IBrokerage>> {
    const cached = this.cacheService.get(this.CACHE_KEYS.BROKERAGE);
    if (cached) {
      return of(cached);
    }

    return this.ctrlApiHttpService.get(`/brokerage/`, {}).pipe(tap((response) => this.cacheService.set(this.CACHE_KEYS.BROKERAGE, response)));
  }

  getAllBrokers(): Observable<ICtrlResponse<IBroker[]>> {
    const cached = this.cacheService.get(this.CACHE_KEYS.AllBROKERS);
    if (cached) {
      return of(cached);
    }

    return this.ctrlApiHttpService.get(`/brokers/search/`, {}).pipe(tap((response) => this.cacheService.set(this.CACHE_KEYS.AllBROKERS, response)));
  }
}
